module.exports = __webpack_public_path__ + "static/media/side_bg.ac78c3c0.jpg";